var render = function(_h, _vm) {
  var _c = _vm._c
  return _c(
    "svg",
    _vm._g(
      _vm._b(
        {
          ref: _vm.data.ref,
          class: [_vm.data.class, _vm.data.staticClass],
          style: [_vm.data.style, _vm.data.staticStyle],
          attrs: {
            version: "1.1",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink"
          }
        },
        "svg",
        _vm.data.attrs,
        false
      ),
      _vm.listeners
    ),
    [
      _c("defs", [
        _c("path", { attrs: { id: _vm.props.pathId, d: "M0,0h3v2h-3Z" } })
      ]),
      _vm._v(" "),
      _c("path", { attrs: { fill: "none", d: "M0,0h24v24h-24Z" } }),
      _vm._v(" "),
      _c("g", [
        _c("use", {
          attrs: { transform: "translate(7, 10)", "xlink:href": "#path-1" }
        }),
        _vm._v(" "),
        _c("use", {
          attrs: { transform: "translate(7, 13)", "xlink:href": "#path-1" }
        }),
        _vm._v(" "),
        _c("use", {
          attrs: { transform: "translate(7, 16)", "xlink:href": "#path-1" }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: { d: "M0,0h5v8h-5Z", transform: "translate(12, 10)" }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M13.414,0h-11.414c-1.103,0 -2,0.898 -2,2v18c0,1.103 0.897,2 2,2h14c1.103,0 2,-0.897 2,-2v-15.414l-4.586,-4.586Zm-11.414,20v-18h10v4h4l0.001,14h-14.001Z",
            transform: "translate(3, 1)"
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }